module.exports = __webpack_public_path__ + "static/banner-financement-hypothecaire-desktop-29e5836577ed39abf5af29fe9aedc4e4.png";